export interface Category {
  name: string;
  namePl: string;
  link: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    namePl: 'Buty',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Najlepsze sneakersy i obuwie w jednym miejscu',
  },
  {
    name: 'Hoodies/Sweaters',
    namePl: 'Bluzy / Swetry',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Bluzy, swetry i ciepłe ubrania na każdą porę roku',
  },
  {
    name: 'T-Shirts',
    namePl: 'T-Shirty',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Koszulki od najlepszych marek w świetnych cenach',
  },
  {
    name: 'Jackets',
    namePl: 'Kurtki',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-windy-line',
    description: 'Kurtki i płaszcze — stylowe i funkcjonalne',
  },
  {
    name: 'Pants/Shorts',
    namePl: 'Spodnie / Szorty',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Spodnie, jeansy i szorty na każdą okazję',
  },
  {
    name: 'Headwear',
    namePl: 'Nakrycia głowy',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-smile-line',
    description: 'Czapki, kapelusze i akcesoria na głowę',
  },
  {
    name: 'Sets',
    namePl: 'Zestawy',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Kompletne zestawy ubrań i akcesoriów',
  },
  {
    name: 'Underwear/Underpants',
    namePl: 'Bielizna',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Bielizna i podstawowe elementy garderoby',
  },
  {
    name: 'Jersey',
    namePl: 'Koszulki sportowe',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-run-line',
    description: 'Koszulki sportowe i odzież treningowa',
  },
  {
    name: 'Accessories',
    namePl: 'Akcesoria',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Okulary, biżuteria i dodatki do stylizacji',
  },
  {
    name: 'Bags',
    namePl: 'Torby',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Torby, plecaki i walizki w różnych stylach',
  },
  {
    name: 'Belts',
    namePl: 'Paski',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Paski skórzane i materiałowe do każdej stylizacji',
  },
  {
    name: 'Perfumes',
    namePl: 'Perfumy',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Zapachy i perfumy od światowych marek',
  },
  {
    name: 'Other Stuff',
    namePl: 'Inne',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Wszystko, czego nie znalazłeś w innych kategoriach',
  },
];